import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../../contexts/AuthContext';
import lavenderIconLight from '../../assets/blue_unfilled_icon_light.png';
import lavenderIconDark from '../../assets/lavender_unfilled_icon_dark.png';

const API_URL = '/api';

function AcceptInvitation() {
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const [projectInfo, setProjectInfo] = useState(null);
  const navigate = useNavigate();
  const { darkMode, token } = useContext(AuthContext);

  useEffect(() => {
    const acceptInvite = async () => {
      // Get token from URL query params
      const params = new URLSearchParams(window.location.search);
      const inviteToken = params.get('token');

      if (!inviteToken) {
        setStatus('error');
        setMessage('Invalid invitation link. No token provided.');
        return;
      }

      // Check if user is logged in
      if (!token) {
        // Redirect to login with return URL
        navigate(`/login?redirect=/accept-invitation&token=${inviteToken}`);
        return;
      }

      try {
        const response = await axios.post(`${API_URL}/accept-invitation`, { token: inviteToken });
        setStatus('success');
        setMessage(response.data.message || 'Successfully joined the project!');
        setProjectInfo(response.data.project);

        // Redirect to project after 3 seconds
        setTimeout(() => {
          navigate(`/projects/${response.data.project.id}`);
        }, 3000);
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Failed to accept invitation. Please try again or contact the project owner.');
      }
    };

    acceptInvite();
  }, [navigate, token]);

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-logo">
          <h1>
            <img src={darkMode ? lavenderIconDark : lavenderIconLight} alt="Ref-Lex Icon" style={{ height: '3em', verticalAlign: 'bottom', marginRight: '0.3em' }} />
            <span className="logo-text">Ref-Lex</span>
          </h1>
          <p className="tagline">Another Reference Manager</p>
        </div>
        <h2>Accept Invitation</h2>

        {status === 'loading' && (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p>Accepting invitation...</p>
            <div style={{ fontSize: '24px', marginTop: '10px' }}>⏳</div>
          </div>
        )}

        {status === 'success' && (
          <div className="success">
            <div style={{ fontSize: '48px', marginBottom: '10px' }}>✓</div>
            <p>{message}</p>
            {projectInfo && (
              <div style={{ marginTop: '20px', padding: '15px', backgroundColor: 'var(--card-bg)', borderRadius: '8px' }}>
                <h3 style={{ marginTop: 0 }}>{projectInfo.name}</h3>
                {projectInfo.description && <p style={{ color: 'var(--text-secondary)' }}>{projectInfo.description}</p>}
              </div>
            )}
            <p style={{ marginTop: '15px', fontSize: '14px', color: 'var(--text-secondary)' }}>
              Redirecting to project...
            </p>
          </div>
        )}

        {status === 'error' && (
          <div>
            <div className="error">
              <div style={{ fontSize: '48px', marginBottom: '10px' }}>✗</div>
              <p>{message}</p>
            </div>
            <div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button onClick={() => navigate('/login')} style={{ flex: 1 }}>
                Go to Login
              </button>
              <button onClick={() => navigate('/')} style={{ flex: 1 }}>
                Go to Projects
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AcceptInvitation;
